import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function signUpCustomer(data) {
  return axios.post(base + "/customers/signup", data);
}
export function getCustomers(token, query) {
  return axios.get(`${baseUrl}/customers`, {
    headers: {
      authorization: token,
    },
  });
}
export function getCustomerById(token, id) {
  return axios.get(`${baseUrl}/customer/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function updateCustomerById(token, id, data) {
  return axios.patch(`${baseUrl}/customer/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}
export function deleteCustomerById(id, token) {
  return axios.delete(`${baseUrl}/customer/${id}`, {
    headers: {
      authorization: token,
    },
  });
}
